import React, { useState, useEffect } from 'react';
import { message, Popover } from 'antd';
import apis from '@/apis/goodsPool';

const renderCateList = (record) => {
  const { inventoryId, categoryNames = [] } = record;
  const PopoverContent = ({ inventoryId }) => {
    const [allCategoryNames, setAllCategoryNames] = useState([]);
    useEffect(() => {
      apis
        .queryAllInventoryCategory({ inventoryId })
        .then((res) => {
          const { ret, msg, data } = res;
          if (ret !== '0' || !data) throw msg;
          setAllCategoryNames(data.list);
        })
        .catch((ex) => {
          message.error(ex || '类目明细请求失败！');
        });
    }, [inventoryId]);
    return (
      <div style={{ maxHeight: '160px', overflow: 'scroll' }}>
        {allCategoryNames.map((item, index) => (
          <div key={index}>{item.cate3Name}</div>
        ))}
      </div>
    );
  };

  return (
    categoryNames.length > 0 && (
      <Popover content={<PopoverContent inventoryId={inventoryId} />} title={<div>全部类目</div>} placement="bottom">
        <div style={{ flex: 1, cursor: 'pointer' }} className="ellipsis-2-line">
          {categoryNames.join('、')}
        </div>
      </Popover>
    )
  );
};

export default renderCateList;
